(function () {
  'use strict';

  var GIFT_THRESHOLD = 10000;
  var GIFT_NAME = 'Bask & Co Granola Bar';

  function fmt(cents) {
    var n = cents / 100;
    return '$' + (Number.isInteger(n) ? n.toFixed(0) : n.toFixed(2));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function tierColor(tier) {
    return { gold: '#b28f60', silver: '#8ca1ba', bronze: '#975942' }[tier] || null;
  }

  function shopifyPost(path, body) {
    var headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (path.indexOf('/cart/add') !== -1) headers['X-CD'] = '1';
    return fetch(path, { method: 'POST', headers: headers, body: JSON.stringify(body) });
  }

  var CartDrawer = {
    el: null,
    overlay: null,
    ringUrl: '',
    lastProductId: null,
    _timer: null,
    _recsCtrl: null,
    _adding: false,
    _notice: '',
    _wantVariant: null,
    _wantQty: 0,
    _recsHtml: '',
    _maxKeys: {},

    init: function () {
      this.el = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-overlay');
      if (!this.el) return;
      this.ringUrl = this.el.dataset.ringUrl || '';
      var self = this;

      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-open-cart-drawer]')) { e.preventDefault(); self.open(); }
      });
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.cart-framework__toggle');
        if (!btn) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = document.getElementById('cart-framework-body');
        if (body) body.hidden = expanded;
      });

    },

    _onQtyChange: function (btn) {
      var key   = btn.dataset.key;
      var row   = btn.closest('.cart-item-row');
      var qtyEl = row ? row.querySelector('.cart-item-row__qty') : null;
      var qty   = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      qty = btn.dataset.action === 'increase' ? qty + 1 : qty - 1;
      if (qty < 1) { this.removeItem(key); return; }
      this.queueUpdate(key, qty);
    },

    _onRemove: function (btn) {
      this.removeItem(btn.dataset.key);
    },

    _onRecAdd: function (btn) {
      var pid  = btn.dataset.productId || '';
      var meta = (window._productTiers && pid && window._productTiers[pid]) || {};
      var tier  = meta.t || '';
      var score = (meta.s && meta.s !== '0') ? meta.s : '';
      this.addItem(btn.dataset.variantId, 1, tier, score, pid);
    },

    // Called by onclick on product page button (button lives OUTSIDE the form)
    addFromForm: function (btn) {
      var form = document.getElementById('product-form');
      if (!form || this._adding) return;
      var variantId = (form.querySelector('[name="id"]') || {}).value;
      var qty       = (form.querySelector('[name="quantity"]') || {}).value || 1;
      var tier      = (form.querySelector('[name="properties[_tier]"]') || {}).value || '';
      var score     = (form.querySelector('[name="properties[_score]"]') || {}).value || '';
      var productId = (form.querySelector('.js-product-id') || {}).value || '';
      if (tier === 'pending') tier = '';
      if (score === '0') score = '';
      if (variantId) this.addItem(variantId, qty, tier, score, productId);
    },

    // Called by onclick on product card button
    addFromCard: function (btn) {
      if (this._adding) return;
      if (btn.dataset.hasVariants === 'true') { window.location.href = btn.dataset.productUrl; return; }
      var card      = btn.closest('.product-card');
      var variantId = btn.dataset.variantId;
      var rawTier   = (card && card.dataset.tier)      || '';
      var rawScore  = (card && card.dataset.score)     || '';
      var productId = (card && card.dataset.productId) || '';
      var tier  = (rawTier  === 'pending' || rawTier  === '') ? '' : rawTier;
      var score = (rawScore === '0'       || rawScore === '') ? '' : rawScore;
      if (variantId) this.addItem(variantId, 1, tier, score, productId);
    },

    open: function () {
      var self = this;
      this.el.classList.add('is-open');
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.el.setAttribute('aria-hidden', 'false');
      this.refresh();
      requestAnimationFrame(function () {
        var b = self.el.querySelector('.cart-drawer__close');
        if (b) b.focus();
      });
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.el.setAttribute('aria-hidden', 'true');
    },

    addItem: function (variantId, qty, tier, score, productId) {
      if (this._adding) return;
      this._adding = true;
      var self = this;
      var numId = Number(variantId);
      var addQty = Number(qty);

      var newProps = {};
      if (tier)  newProps['_tier']  = tier;
      if (score) newProps['_score'] = score;

      this._showSpinner();
      if (!this.el.classList.contains('is-open')) {
        this.el.classList.add('is-open');
        this.overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        this.el.setAttribute('aria-hidden', 'false');
      }

      // Fetch cart first to check for existing line items with same variant
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var matches = cart.items.filter(function (i) { return i.variant_id === numId; });

          if (matches.length === 0) {
            // No existing item — straightforward add
            self._wantVariant = numId;
            self._wantQty = addQty;
            var body = { items: [{ id: numId, quantity: addQty }] };
            if (Object.keys(newProps).length) body.items[0].properties = newProps;
            return shopifyPost('/cart/add.js', body);
          }

          // Item(s) already in cart — consolidate into first match
          // Sum all quantities (existing + newly requested) on the primary line item
          var primary   = matches[0];
          var totalQty  = addQty;
          matches.forEach(function (m) { totalQty += m.quantity; });

          // Remember what we asked for so a server-side clamp can be spotted after refresh.
          self._wantVariant = numId;
          self._wantQty = totalQty;

          // Merge existing properties with new ones (new tier/score wins)
          var merged = {};
          var existingProps = primary.properties || {};
          Object.keys(existingProps).forEach(function (k) { merged[k] = existingProps[k]; });
          Object.keys(newProps).forEach(function (k) { merged[k] = newProps[k]; });

          // Update primary line item with consolidated qty + merged props
          var chain = shopifyPost('/cart/change.js', {
            id: primary.key,
            quantity: totalQty,
            properties: merged
          });

          // Remove any duplicate line items (beyond the first)
          for (var i = 1; i < matches.length; i++) {
            chain = chain.then((function (dup) {
              return function () {
                return shopifyPost('/cart/change.js', { id: dup.key, quantity: 0 });
              };
            })(matches[i]));
          }

          return chain;
        })
        .then(function (res) {
          // Shopify answers 422 when the requested quantity exceeds stock, and adds
          // nothing. This used to fall through silently, so the drawer slid open showing
          // an unchanged cart with no explanation.
          if (res && res.ok === false) {
            return res.json().catch(function () { return null; }).then(function (err) {
              self._notice = (err && (err.description || err.message)) ||
                'That quantity is not available.';
            });
          }
        })
        .then(function () {
          if (productId) self.lastProductId = productId;
          return self.refresh(true);
        })
        .catch(function (err) { console.error('[CartDrawer] add failed:', err); })
        .finally(function () { self._adding = false; window._cdBlocking = false; });
    },

    _showSpinner: function () {
      var body = this.el.querySelector('.cart-drawer__body');
      if (body) body.innerHTML = '<div class="cart-drawer__loading"><div class="cart-drawer__spinner"></div></div>';
      var footer = this.el.querySelector('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
    },

    refresh: function (manage, skipRecs) {
      var self = this;
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!manage) { self.render(cart, skipRecs); return; }
          return self.manageGift(cart).then(function () {
            return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r) { return r.json(); })
              .then(function (fresh) { self.render(fresh, skipRecs); });
          });
        })
        .catch(function (err) { console.error('[CartDrawer] refresh failed:', err); });
    },

    manageGift: function (cart) {
      var subtotal  = cart.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var GIFT_NOTE = 'Gift unlocked: ' + GIFT_NAME;
      var current   = cart.note || '';
      var desired   = subtotal >= GIFT_THRESHOLD ? GIFT_NOTE : (current === GIFT_NOTE ? '' : current);
      if (desired === current) return Promise.resolve();
      return shopifyPost('/cart/update.js', { note: desired }).then(function () {});
    },

    render: function (cart, skipRecs) {
      var self   = this;
      var body   = this.el.querySelector('.cart-drawer__body');
      var footer = this.el.querySelector('.cart-drawer__footer');
      if (!body || !footer) return;

      var subtotal  = cart.items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var pct       = Math.min(100, Math.round((subtotal / GIFT_THRESHOLD) * 100));
      var remaining = Math.max(0, GIFT_THRESHOLD - subtotal);
      var unlocked  = subtotal >= GIFT_THRESHOLD;

      this.updateHeaderCount(cart.item_count);

      if (cart.item_count === 0) {
        this._recsHtml = '';
        this._notice = '';
        body.innerHTML = '<div class="cart-drawer__empty"><p class="cart-drawer__empty-text">Your pantry is ready when you are.</p><a href="/collections/all" class="cart-drawer__empty-link" onclick="CartDrawer.close()">Browse products</a></div>';
        footer.style.display = 'none';
        return;
      }

      var progressHtml = '<div class="cart-progress' + (unlocked ? ' cart-progress--unlocked' : '') + '"><p class="cart-progress__text">'
        + (unlocked ? '<strong>You\'ve unlocked a complimentary ' + GIFT_NAME + '.</strong>' : 'You\'re <strong>' + fmt(remaining) + '</strong> away from a complimentary ' + GIFT_NAME + '.')
        + '</p><div class="cart-progress__bar"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div></div>';

      var frameworkHtml = '<div class="cart-framework"><button class="cart-framework__toggle" aria-expanded="false" aria-controls="cart-framework-body"><span class="cart-framework__label"><em>Every product here has earned its place.</em></span><svg class="cart-framework__icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg></button><div id="cart-framework-body" class="cart-framework__body" hidden>Every product you see below has been independently assessed via The Reference. Framework. Products are scored across ingredient integrity, processing level, nutritional value, sourcing and transparency and simplicity... because choosing better food shouldn\'t require decoding labels.</div></div>';

      var itemsHtml = cart.items.map(function (item) { return self.renderItem(item); }).join('');

      var noticeHtml = '';
      if (this._notice) {
        noticeHtml = '<div class="cart-drawer__notice" role="status" style="margin:0 0 14px;padding:10px 13px;' +
          'background:rgba(151,89,66,0.08);border:1px solid rgba(151,89,66,0.3);border-left-width:3px;' +
          'border-radius:3px;font-size:12.5px;line-height:1.5;color:var(--charcoal,#1b1b1b)">' +
          escapeHtml(this._notice) + '</div>';
        this._notice = '';
      }

      body.innerHTML = noticeHtml + progressHtml + frameworkHtml + '<div class="cart-drawer__items">' + itemsHtml + '</div><div id="cart-recs-slot" class="cart-recs"></div>';

      // Restore cached recs immediately so they don't flicker out on every render
      if (this._recsHtml) {
        var recsSlot = document.getElementById('cart-recs-slot');
        if (recsSlot) recsSlot.innerHTML = this._recsHtml;
      }

      footer.style.display = '';
      footer.innerHTML = '<div class="cart-drawer__subtotal"><span class="cart-drawer__subtotal-label">Subtotal</span><span class="cart-drawer__subtotal-amount">' + fmt(cart.total_price) + '</span></div><a href="/checkout" class="cart-drawer__checkout"><span>Proceed to Checkout</span></a><button class="cart-drawer__continue" onclick="CartDrawer.close()">Continue building your pantry</button>';

      if (!skipRecs) this.loadRecommendations(cart);
      this.updateInventoryButtons(cart);
    },

    renderItem: function (item) {
      var tier  = (item.properties && item.properties._tier)  || '';
      var score = (item.properties && item.properties._score) || '';
      // Fallback: rec-adds and any item missing properties still get a badge
      if (!tier && !score && window._productTiers) {
        var _m = window._productTiers[String(item.product_id)] || {};
        tier  = _m.t || '';
        score = (_m.s && _m.s !== '0') ? _m.s : '';
      }
      var color = tierColor(tier);
      var label = color ? (tier.charAt(0).toUpperCase() + tier.slice(1)) : '';

      var tierScoreHtml = '';
      if (label || (score && score !== '0')) {
        var inner = '';
        if (label) {
          inner += '<span class="cart-item-row__tier-dot-sm" style="background:' + color
            + ';-webkit-mask-image:url(' + JSON.stringify(this.ringUrl)
            + ');mask-image:url(' + JSON.stringify(this.ringUrl) + ')"></span>'
            + '<span style="color:' + color + '">' + label + '</span>';
        }
        if (label && score && score !== '0') inner += '<span style="color:var(--beige);margin:0 2px">·</span>';
        if (score && score !== '0') inner += '<span style="color:var(--stone)">' + score + '/100</span>';
        tierScoreHtml = '<span class="cart-item-row__ctrl-sep"></span><span class="cart-item-row__tier-inline">' + inner + '</span>';
      }

      var imgEl = item.image
        ? '<img class="cart-item-row__img" src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy" width="72" height="72">'
        : '<div class="cart-item-row__img" style="display:flex;align-items:center;justify-content:center;color:rgba(107,105,106,0.25);font-size:22px;font-weight:600">' + ((item.product_title || '?').charAt(0)) + '</div>';

      return '<div class="cart-item-row" data-key="' + item.key + '">'
        + '<a href="' + item.url + '" tabindex="-1">' + imgEl + '</a>'
        + '<div class="cart-item-row__info">'
        + '<div class="cart-item-row__name">' + (item.product_title || item.title) + '</div>'
        + '<div class="cart-item-row__controls">'
        + '<button class="cart-item-row__qty-btn" data-action="decrease" data-key="' + item.key + '" onclick="CartDrawer._onQtyChange(this)" aria-label="Decrease quantity">−</button>'
        + '<span class="cart-item-row__qty">' + item.quantity + '</span>'
        + '<button class="cart-item-row__qty-btn" data-action="increase" data-key="' + item.key + '" onclick="CartDrawer._onQtyChange(this)" aria-label="Increase quantity">+</button>'
        + '<span class="cart-item-row__ctrl-sep"></span>'
        + '<button class="cart-item-row__remove" data-key="' + item.key + '" onclick="CartDrawer._onRemove(this)" aria-label="Remove item">Remove</button>'
        + tierScoreHtml
        + '</div></div>'
        + '<div class="cart-item-row__price">' + fmt(item.final_line_price) + '</div>'
        + '</div>';
    },

    _greyIncreaseBtn: function (key) {
      var row = this.el.querySelector('.cart-item-row[data-key="' + key + '"]');
      if (!row) return;
      var btn = row.querySelector('.cart-item-row__qty-btn[data-action="increase"]');
      if (btn) {
        btn.disabled = true;
        btn.style.cssText = 'background:#6b696a;color:#f4f3ee;cursor:not-allowed;opacity:1;pointer-events:none;border-radius:2px;';
      }
    },

    updateInventoryButtons: function (cart) {
      var self = this;
      // Path 1: inventory baked into _productTiers via Liquid at page load
      var tiers = window._productTiers;
      if (tiers) {
        cart.items.forEach(function (item) {
          var meta = tiers[String(item.product_id)] || {};
          var invMap = meta.m || {};
          var max = invMap[String(item.variant_id)];
          if (max === undefined || max < 0) return;
          if (item.quantity >= max) self._greyIncreaseBtn(item.key);
        });
      }
      // Path 2: the server gave us less than we asked for on the last add, so that line
      // is at its ceiling. This is what covers products the map above cannot reach, and
      // it is authoritative because the cart is the source of truth, not a page-load
      // snapshot.
      if (self._wantVariant !== null) {
        cart.items.forEach(function (item) {
          if (item.variant_id === self._wantVariant && item.quantity < self._wantQty) {
            self._maxKeys[item.key] = true;
          }
        });
        self._wantVariant = null;
        self._wantQty = 0;
      }

      // Path 3: confirmed by Shopify silently capping a qty-increase attempt
      cart.items.forEach(function (item) {
        if (self._maxKeys[item.key]) self._greyIncreaseBtn(item.key);
      });
    },

    queueUpdate: function (key, qty) {
      var self = this;
      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        shopifyPost('/cart/change.js', { id: key, quantity: qty })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Detect silent inventory cap: Shopify returns qty < requested
            var updated = (cart.items || []).filter(function (i) { return i.key === key; })[0];
            if (updated && updated.quantity < qty) {
              self._maxKeys[key] = true;
            } else if (updated) {
              delete self._maxKeys[key];
            }
            return self.refresh(true, true);
          });
      }, 280);
    },

    removeItem: function (key) {
      var self = this;
      return shopifyPost('/cart/change.js', { id: key, quantity: 0 })
        .then(function () { return self.refresh(true); });
    },

    loadRecommendations: function (cart) {
      var self = this;
      var slot = document.getElementById('cart-recs-slot');
      if (!slot) return;
      var productId = this.lastProductId || (cart.items.length ? cart.items[cart.items.length - 1].product_id : null);
      if (!productId) return;
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      if (this._recsCtrl) { try { this._recsCtrl.abort(); } catch (e) {} }
      this._recsCtrl = new AbortController();
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related', {
        signal: this._recsCtrl.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var recs = (data.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 3);
          if (!recs.length) { slot.innerHTML = ''; return; }
          var html = '<p class="cart-recs__heading">Complete your pantry</p><div class="cart-recs__list">';
          recs.forEach(function (p) {
            var imgSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.url) || '';
            var imgEl  = imgSrc ? '<img class="cart-rec-card__img" src="' + imgSrc + '" alt="' + (p.title || '') + '" loading="lazy" width="116" height="116">' : '<div class="cart-rec-card__img"></div>';
            var varId  = p.variants && p.variants[0] ? p.variants[0].id : '';
            html += '<div class="cart-rec-card">' + imgEl + '<p class="cart-rec-card__name">' + (p.title || '') + '</p><p class="cart-rec-card__price">' + fmt(p.price) + '</p><button class="cart-rec-card__add" data-variant-id="' + varId + '" data-product-id="' + p.id + '" onclick="CartDrawer._onRecAdd(this)">+ Add</button></div>';
          });
          html += '</div>';
          slot.innerHTML = html;
          self._recsHtml = html;
        })
        .catch(function (err) { if (err.name !== 'AbortError') console.error('[CartDrawer] recs error:', err); });
    },

    updateHeaderCount: function (count) {
      var bubble = document.getElementById('cart-count-bubble');
      if (!bubble) return;
      if (count > 0) { bubble.textContent = count; bubble.style.display = ''; }
      else { bubble.style.display = 'none'; }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CartDrawer.init(); });
  } else {
    CartDrawer.init();
  }
  window.CartDrawer = CartDrawer;
})();
